export default "__VITE_ASSET__B6dEOd3Z__"